/* lib/api/profile.js — порт боевого клиента профиля/безопасности (frontend/src/lib/api/profile.js, 1:1).
 * Скоуп — текущий user (сессия Django), НЕ workspace. Контракт {ok,status,data}.
 * Серверный сериализатор смены email ждёт {new_email, password} (НЕ current_password) — маппит адаптер.
 * Avatar upload/delete тут оставлены для паритета порта, но в прототипе НЕ проводятся в фасад
 * (см. дыру «Avatar» в adapters/settings.js — кнопки остаются локальным демо). */

import { apiFetch } from './client.js';

export const updateProfile = (body) =>
  apiFetch('/api/auth/profile/', { method: 'PATCH', body });

export const uploadAvatar = (file) => {
  const fd = new FormData();
  fd.append('avatar', file);
  return apiFetch('/api/auth/profile/avatar/', { method: 'POST', body: fd });
};

export const deleteAvatar = () =>
  apiFetch('/api/auth/profile/avatar/', { method: 'DELETE' });

export const requestEmailChange = (body) =>
  apiFetch('/api/auth/profile/email/change/', { method: 'POST', body });

export const confirmEmailChange = (body) =>
  apiFetch('/api/auth/profile/email/change/confirm/', { method: 'POST', body });

export const cancelEmailChange = () =>
  apiFetch('/api/auth/profile/email/change/cancel/', { method: 'POST', body: {} });

export const changePassword = (body) =>
  apiFetch('/api/auth/profile/password/change/', { method: 'POST', body });

export const revokeOtherSessions = () =>
  apiFetch('/api/auth/profile/sessions/revoke-all/', { method: 'POST', body: {} });

export const deleteAccount = (body) =>
  apiFetch('/api/auth/profile/account/delete/', { method: 'POST', body });
